/* Football Masters market attribution bridge.
 * Persists UTM/click IDs and writes them to Shopify cart attributes before checkout.
 */
(function () {
  "use strict";

  if (window.__fmAttributionLoaded) return;
  window.__fmAttributionLoaded = true;

  var VERSION = "2026-06-16.eu-attribution-cart-v1";
  var STORAGE_KEY = "fmAttribution.v1";
  var MAX_VALUE_LENGTH = 512;
  var PARAM_KEYS = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gbraid",
    "wbraid",
    "fbclid",
    "ttclid",
    "msclkid",
    "campaign_id",
    "ad_id",
    "adset_id",
    "fm_market",
    "discount"
  ];

  var MARKETS = {
    cz: {
      hosts: ["footballmasters.cz", "www.footballmasters.cz"],
      lang: /^cs/i,
      pathPrefix: /^\/cs(\/|$)/i,
      currency: "CZK",
      discount: "CZGK50"
    },
    sk: {
      hosts: ["footballmasters.sk", "www.footballmasters.sk"],
      lang: /^sk/i,
      pathPrefix: /^\/sk(\/|$)/i,
      currency: "EUR",
      discount: "SKGK50"
    },
    ro: {
      hosts: ["footballmasters.ro", "www.footballmasters.ro"],
      lang: /^ro/i,
      pathPrefix: /^\/ro-ro(\/|$)/i,
      currency: "RON",
      discount: "ROGK50"
    },
    de: {
      hosts: ["footballmasters.com.de", "www.footballmasters.com.de"],
      lang: /^de/i,
      pathPrefix: /^\/de(\/|$)/i,
      currency: "EUR",
      discount: "DEGK50"
    }
  };

  function clean(value, maxLength) {
    var next = String(value || "").replace(/\s+/g, " ").trim();
    return next.slice(0, maxLength || MAX_VALUE_LENGTH);
  }

  function getMarket() {
    var host = (window.location.hostname || "").toLowerCase();
    var path = window.location.pathname || "/";
    var lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    var keys = Object.keys(MARKETS);
    for (var index = 0; index < keys.length; index += 1) {
      var market = keys[index];
      var config = MARKETS[market];
      if (config.hosts.indexOf(host) !== -1 || config.pathPrefix.test(path) || config.lang.test(lang)) {
        return {
          code: market,
          currency: config.currency,
          discount: config.discount
        };
      }
    }
    return {
      code: "pro",
      currency: "PLN",
      discount: ""
    };
  }

  function readStorage() {
    try {
      var raw = window.localStorage && window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) || {} : {};
    } catch (error) {
      return {};
    }
  }

  function writeStorage(payload) {
    try {
      if (window.localStorage) window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (error) {}
  }

  function pageUrl() {
    try {
      var url = new URL(window.location.href);
      url.hash = "";
      return url.toString();
    } catch (error) {
      return window.location.href || "";
    }
  }

  function readIncomingParams() {
    var incoming = {};
    try {
      var params = new URLSearchParams(window.location.search || "");
      PARAM_KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value) incoming[key] = clean(value, 255);
      });
    } catch (error) {}
    return incoming;
  }

  function hasIncomingTraffic(params) {
    return PARAM_KEYS.some(function (key) {
      return Boolean(params[key]);
    });
  }

  function captureAttribution() {
    var market = getMarket();
    var stored = readStorage();
    var now = new Date().toISOString();
    var current = pageUrl();
    var params = readIncomingParams();
    var hasIncoming = hasIncomingTraffic(params);

    if (!stored.first_seen_at) stored.first_seen_at = now;
    if (!stored.first_landing_url) stored.first_landing_url = current;
    if (!stored.first_referrer && document.referrer) stored.first_referrer = clean(document.referrer);
    if (!stored.first_market) stored.first_market = market.code;

    stored.last_seen_at = now;
    stored.last_landing_url = current;
    stored.last_referrer = clean(document.referrer || stored.last_referrer || "");
    stored.last_market = market.code;
    stored.last_currency = market.currency;

    if (hasIncoming) {
      if (!stored.first_touch_params) stored.first_touch_params = params;
      stored.last_touch_params = params;
    } else if (!stored.last_touch_params) {
      stored.last_touch_params = {};
    }

    if (!stored.last_touch_params.discount && market.discount) {
      stored.last_touch_params.discount = market.discount;
    }

    writeStorage(stored);
    return stored;
  }

  function buildAttributes(reason) {
    var market = getMarket();
    var stored = captureAttribution();
    var params = stored.last_touch_params || {};
    var firstParams = stored.first_touch_params || {};
    return {
      fm_attr_version: VERSION,
      fm_attr_reason: clean(reason || "storefront", 64),
      fm_market: clean(params.fm_market || stored.last_market || market.code, 32),
      fm_currency: clean(stored.last_currency || market.currency, 16),
      fm_discount_code: clean((params.discount || market.discount || "").toUpperCase(), 32),
      fm_landing_url: clean(stored.first_landing_url || stored.last_landing_url || pageUrl()),
      fm_current_url: clean(stored.last_landing_url || pageUrl()),
      fm_referrer: clean(stored.first_referrer || stored.last_referrer || document.referrer || ""),
      fm_first_seen_at: clean(stored.first_seen_at || "", 64),
      fm_last_seen_at: clean(stored.last_seen_at || "", 64),
      fm_utm_source: clean(params.utm_source || firstParams.utm_source || "", 128),
      fm_utm_medium: clean(params.utm_medium || firstParams.utm_medium || "", 128),
      fm_utm_campaign: clean(params.utm_campaign || firstParams.utm_campaign || "", 255),
      fm_utm_content: clean(params.utm_content || firstParams.utm_content || "", 255),
      fm_utm_term: clean(params.utm_term || firstParams.utm_term || "", 255),
      fm_gclid: clean(params.gclid || firstParams.gclid || params.gbraid || params.wbraid || "", 255),
      fm_fbclid: clean(params.fbclid || firstParams.fbclid || "", 255),
      fm_ttclid: clean(params.ttclid || firstParams.ttclid || "", 255),
      fm_msclkid: clean(params.msclkid || firstParams.msclkid || "", 255),
      fm_campaign_id: clean(params.campaign_id || firstParams.campaign_id || "", 128),
      fm_adset_id: clean(params.adset_id || firstParams.adset_id || "", 128),
      fm_ad_id: clean(params.ad_id || firstParams.ad_id || "", 128)
    };
  }

  function compactAttributes(attributes) {
    var next = {};
    Object.keys(attributes || {}).forEach(function (key) {
      var value = clean(attributes[key]);
      if (value) next[key] = value;
    });
    return next;
  }

  function upsertHidden(form, name, value) {
    if (!form || !name || !value) return;
    var selector = 'input[type="hidden"][name="' + name.replace(/"/g, '\\"') + '"]';
    var input = form.querySelector(selector);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }
    input.value = clean(value);
  }

  function decorateForms(root) {
    if (!root || !root.querySelectorAll) return;
    var attributes = compactAttributes(buildAttributes("form_decorate"));
    root.querySelectorAll("form[action]").forEach(function (form) {
      var action = form.getAttribute("action") || "";
      if (/\/cart\/add/i.test(action)) {
        [
          "fm_market",
          "fm_currency",
          "fm_discount_code",
          "fm_utm_source",
          "fm_utm_medium",
          "fm_utm_campaign",
          "fm_utm_content",
          "fm_utm_term",
          "fm_gclid",
          "fm_fbclid",
          "fm_ttclid",
          "fm_campaign_id",
          "fm_adset_id",
          "fm_ad_id"
        ].forEach(function (key) {
          upsertHidden(form, "properties[_" + key + "]", attributes[key]);
        });
      }
      if (/\/cart(?:\/|$|\?)/i.test(action)) {
        Object.keys(attributes).forEach(function (key) {
          upsertHidden(form, "attributes[" + key + "]", attributes[key]);
        });
      }
    });
  }

  var syncInFlight = false;
  function syncCartAttributes(reason) {
    if (syncInFlight) return Promise.resolve(false);
    syncInFlight = true;
    var attributes = compactAttributes(buildAttributes(reason));
    window.__fmAttributionState = {
      version: VERSION,
      market: attributes.fm_market || getMarket().code,
      attributes: attributes
    };

    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "content-type": "application/json",
        "accept": "application/json"
      },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (response) {
        return response && response.ok;
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        syncInFlight = false;
      });
  }

  function bindEvents() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.action) return;
      decorateForms(form.parentElement || document);
      if (/\/cart\/add/i.test(form.action)) {
        syncCartAttributes("cart_add_submit");
      } else if (/\/cart/i.test(form.action) && event.submitter && event.submitter.name === "checkout") {
        syncCartAttributes("checkout_submit");
      }
    }, true);

    document.addEventListener("click", function (event) {
      var target = event.target && event.target.closest ? event.target.closest("a, button, input[type='submit']") : null;
      if (!target) return;
      var href = target.getAttribute("href") || "";
      var name = target.getAttribute("name") || "";
      var value = target.getAttribute("value") || "";
      var text = target.textContent || "";
      if (/\/checkout/i.test(href) || name === "checkout" || /checkout|pokladna|pokladne|pokladny|finalizare|kasse/i.test(value + " " + text)) {
        decorateForms(document);
        syncCartAttributes("checkout_click");
      }
    }, true);

    var originalFetch = window.fetch;
    if (originalFetch && !window.__fmAttributionFetchPatched) {
      window.__fmAttributionFetchPatched = true;
      window.fetch = function () {
        var request = arguments[0];
        var url = typeof request === "string" ? request : request && request.url;
        var isCartAdd = url && /\/cart\/add/i.test(url);
        return originalFetch.apply(this, arguments).then(function (response) {
          if (isCartAdd && response && response.ok) {
            syncCartAttributes("cart_add_fetch");
          }
          return response;
        });
      };
    }
  }

  captureAttribution();
  decorateForms(document);
  bindEvents();

  var timer = null;
  new MutationObserver(function () {
    if (timer) window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      decorateForms(document);
    }, 120);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.__fmAttributionVersion = VERSION;
})();
